import { Box, Button, TextField, Typography } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useDataProvider, useNotify } from 'react-admin';
import { GeneralSettings } from '../../types/generalSettings';
import parse from 'html-react-parser';
import "./style.css";

const checkIfURL = (url: string) => {
    const pattern = /(http?:\/\/[^\s]+)/
    return !!pattern.test(url);
}

const titles = ['Dreamhome', 'Lifestyle', 'FixedOdds']

const EmailCountdown: FC = () => {

    const dataProvider = useDataProvider()
    const notify = useNotify()

    const [state, setState] = useState({
        value: { raffle: '', prize: '', fixedOdds: '' },
        error: { raffle: false, prize: false, fixedOdds: false }
    })

    const [general, setGeneral] = useState<GeneralSettings>({} as any)

    useEffect(() => {
        getCountdown()
    }, [])

    const getCountdown = async () => {
        const { data } = await dataProvider.getGeneral();
        if (data.emailCountdowns) {
            const countdowns = data.emailCountdowns
            setState({ ...state, value: countdowns })
        }
        setGeneral(data)
    }

    const saveLink = async () => {
        for (const key in state.value) {
            const element = parse(state.value[key])
            if (Array.isArray(element) || element.type !== 'img') {
               notify("The form is not valid, Please check for error", "error")
               return
            }
        }
        const result = await dataProvider.updateGeneral({
            id: general._id,
            data: { emailCountdowns: state.value },
            previousData: {} as any,
        });
        if (result.data) {
            notify("countdowns saved", "info")
        }
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = state.value
        const valueName = event.target.name
        value[valueName] = event.target.value
        setState({ ...state, value: value })
    }

    const openNewTab = () => {
        window.open('https://www.sendtric.com/', '_blank', 'noopener,noreferrer')
    }

    const parseStringToHTML = (str: string, key: string): JSX.Element => {
        const element = parse(str)
        if (!Array.isArray(element) && element.type === 'img') {
            return element
        }
        return <div className="link-error"> invalid link</div>
    }

    return (
        <Box className="email-coupon-wrapper">
            <Box>
                <Typography className="base-color">
                    Generate link <span id="link" onClick={openNewTab}>here</span> add past in input
                </Typography>
                {Object.keys(state.value).map((item, i) => {
                    return (
                        <Box display="flex" alignItems="center" padding="20px" key={i}>
                            <Typography>
                                {titles[i]}
                            </Typography>
                            <Box padding="0 20px">
                                <TextField
                                    label=""
                                    size="small"
                                    variant="outlined"
                                    type="email"
                                    name={item}
                                    onChange={handleChange}
                                    value={state.value[item]}
                                />
                            </Box>
                            {parseStringToHTML(state.value[item], item)}
                        </Box>
                    )
                })}
            </Box>
            <Box>
                <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    onClick={saveLink}
                >
                    Save
                </Button>
            </Box>
        </Box>
    )
}

export default EmailCountdown